<template>
  <sub-page title="就业困难人员认定">
    <div class="certify-page">
      <!-- 用户信息 -->
      <div class="user-card">
        <div class="avatar">
          <svg viewBox="0 0 24 24" class="avatar-icon"><circle cx="12" cy="8" r="4" fill="#c8c9cc"/><path d="M4 20 C4 15 8 13 12 13 C16 13 20 15 20 20 Z" fill="#c8c9cc"/></svg>
        </div>
        <div class="user-info">
          <div class="user-name">**杰</div>
          <div class="user-id">**************5619</div>
        </div>
      </div>

      <!-- 表单 -->
      <div class="form-body" @click="onFormClick">
        <div class="form-item">
          <span class="form-label required">性别</span>
          <div class="picker" @click="selectField('性别')">
            <span :class="['picker-value', { placeholder: !form.gender }]">{{ form.gender || '请选择' }}</span>
            <svg viewBox="0 0 24 24" class="picker-arrow"><path d="M9 6 L17 12 L9 18" fill="none" stroke="#c8c9cc" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>
          </div>
        </div>
        <div class="form-item">
          <span class="form-label required">民族</span>
          <div class="picker" @click="selectField('民族')">
            <span :class="['picker-value', { placeholder: !form.nation }]">{{ form.nation || '请选择' }}</span>
            <svg viewBox="0 0 24 24" class="picker-arrow"><path d="M9 6 L17 12 L9 18" fill="none" stroke="#c8c9cc" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>
          </div>
        </div>
        <div class="form-item">
          <span class="form-label required">联系电话</span>
          <div class="input-wrap">
            <input v-model="form.phone" class="form-input" placeholder="请输入联系电话" />
            <svg v-if="form.phone" @click="form.phone = ''" viewBox="0 0 24 24" class="clear-btn"><circle cx="12" cy="12" r="9" fill="#c8c9cc"/><path d="M8 8 L16 16 M16 8 L8 16" stroke="#fff" stroke-width="2" stroke-linecap="round"/></svg>
          </div>
        </div>
        <div class="form-item">
          <span class="form-label required">学历</span>
          <div class="picker" @click="selectField('学历')">
            <span :class="['picker-value', { placeholder: !form.education }]">{{ form.education || '请选择' }}</span>
            <svg viewBox="0 0 24 24" class="picker-arrow"><path d="M9 6 L17 12 L9 18" fill="none" stroke="#c8c9cc" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>
          </div>
        </div>
        <div class="form-item">
          <span class="form-label required">户籍</span>
          <div class="picker" @click="selectField('户籍')">
            <span :class="['picker-value', { placeholder: !form.household }]">{{ form.household || '请选择' }}</span>
            <svg viewBox="0 0 24 24" class="picker-arrow"><path d="M9 6 L17 12 L9 18" fill="none" stroke="#c8c9cc" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>
          </div>
        </div>
        <div class="form-item">
          <span class="form-label required">户籍地址</span>
          <input v-model="form.householdAddr" class="form-input" placeholder="请输入户籍地址" />
        </div>
        <div class="form-item">
          <span class="form-label required">常驻区划</span>
          <div class="picker" @click="selectField('常驻区划')">
            <span :class="['picker-value', { placeholder: !form.residentRegion }]">{{ form.residentRegion || '请选择' }}</span>
            <svg viewBox="0 0 24 24" class="picker-arrow"><path d="M9 6 L17 12 L9 18" fill="none" stroke="#c8c9cc" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>
          </div>
        </div>
        <div class="form-item">
          <span class="form-label required">常住地址</span>
          <input v-model="form.residentAddr" class="form-input" placeholder="请输入常住地址" />
        </div>
        <div class="form-item">
          <span class="form-label required">失业登记时间</span>
          <div class="picker" @click="selectField('失业登记时间')">
            <span :class="['picker-value', { placeholder: !form.unemployDate }]">{{ form.unemployDate || '请选择' }}</span>
            <svg viewBox="0 0 24 24" class="picker-arrow"><path d="M9 6 L17 12 L9 18" fill="none" stroke="#c8c9cc" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>
          </div>
        </div>
        <div class="form-item">
          <span class="form-label required">失业登记原因</span>
          <div class="picker" @click="selectField('失业登记原因')">
            <span :class="['picker-value', { placeholder: !form.unemployReason }]">{{ form.unemployReason || '请选择' }}</span>
            <svg viewBox="0 0 24 24" class="picker-arrow"><path d="M9 6 L17 12 L9 18" fill="none" stroke="#c8c9cc" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>
          </div>
        </div>
        <div class="form-item">
          <span class="form-label required">困难类型</span>
          <div class="picker" @click="selectField('困难类型')">
            <span :class="['picker-value', { placeholder: !form.hardshipType }]">{{ form.hardshipType || '请选择' }}</span>
            <svg viewBox="0 0 24 24" class="picker-arrow"><path d="M9 6 L17 12 L9 18" fill="none" stroke="#c8c9cc" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>
          </div>
        </div>
      </div>

      <!-- 底部按钮 -->
      <div class="footer-btn">
        <button class="submit-btn" @click="handleSubmit">提交</button>
      </div>

      <!-- 字段选择 -->
      <field-sheet
        :show="sheet.show"
        :title="sheet.title"
        :options="sheet.options"
        :value="sheet.value"
        @select="onSheetSelect"
        @close="sheet.show = false"
      />
    </div>
  </sub-page>
</template>

<script>
import SubPage from './SubPage.vue'
import FieldSheet from '@/components/FieldSheet.vue'

export default {
  name: 'HardshipCertify',
  components: { SubPage, FieldSheet },
  data() {
    return {
      form: {
        gender: '',
        nation: '',
        phone: '',
        education: '',
        household: '',
        householdAddr: '',
        residentRegion: '',
        residentAddr: '',
        unemployDate: '',
        unemployReason: '',
        hardshipType: ''
      },
      fieldOptions: {
        '性别': { key: 'gender', options: ['男', '女'] },
        '民族': { key: 'nation', options: ['汉族', '回族', '满族', '其他'] },
        '学历': { key: 'education', options: ['博士研究生', '硕士研究生', '大学本科', '大学专科', '高中', '初中及以下'] },
        '户籍': { key: 'household', options: ['本省城镇', '本省农村', '外省城镇', '外省农村'] },
        '常驻区划': { key: 'residentRegion', options: ['南京市玄武区', '南京市秦淮区', '南京市建邺区', '南京市鼓楼区', '南京市浦口区', '南京市栖霞区', '南京市雨花台区', '南京市江宁区', '南京市六合区', '南京市溧水区', '南京市高淳区', '南京市江北新区'] },
        '失业登记时间': { key: 'unemployDate', options: ['2026-09', '2026-08', '2026-07', '2026-06', '2026-05', '2026-04', '2026-03', '2026-02', '2026-01'] },
        '失业登记原因': { key: 'unemployReason', options: ['被企业解除或终止劳动关系', '企业破产倒闭终止劳动关系', '辞职', '合同期满未续签', '其他'] },
        '困难类型': { key: 'hardshipType', options: ['大龄失业人员（男满50、女满40周岁）', '城镇零就业家庭人员', '享受最低生活保障人员', '连续失业6个月以上人员', '低保家庭人员', '残疾人员', '特困人员'] }
      },
      sheet: { show: false, title: '', options: [], value: '', key: '' }
    }
  },
  methods: {
    selectField(name) {
      const conf = this.fieldOptions[name]
      if (!conf) return
      this.sheet = { show: true, title: '请选择' + name, options: conf.options, value: this.form[conf.key], key: conf.key }
    },
    onFormClick(e) {
      const item = e.target.closest('.form-item')
      if (!item) return
      const label = item.querySelector('.form-label')
      if (label) this.selectField(label.textContent.replace(/^\*/, ''))
    },
    onSheetSelect(val) {
      this.form[this.sheet.key] = val
      this.sheet.show = false
    },
    handleSubmit() {
      const f = this.form
      const checks = [
        [!f.gender, '请选择性别'],
        [!f.nation, '请选择民族'],
        [!f.phone, '请输入联系电话'],
        [!f.education, '请选择学历'],
        [!f.household, '请选择户籍'],
        [!f.householdAddr, '请输入户籍地址'],
        [!f.residentRegion, '请选择常驻区划'],
        [!f.residentAddr, '请输入常住地址'],
        [!f.unemployDate, '请选择失业登记时间'],
        [!f.unemployReason, '请选择失业登记原因'],
        [!f.hardshipType, '请选择困难类型']
      ]
      for (const [cond, msg] of checks) {
        if (cond) { this.$alert(msg); return }
      }
      if (!/^1[3-9]\d{9}$/.test(f.phone)) {
        this.$alert('请输入正确的联系电话')
        return
      }
      this.$alert('就业困难人员认定申请已提交，请等待街道（乡镇）人社机构审核')
    }
  }
}
</script>

<style scoped>
.certify-page {
  background: #F3F8FB;
  min-height: 100%;
  padding-bottom: calc(40 * var(--w));
}
.user-card {
  display: flex;
  align-items: center;
  background: #fff;
  padding: calc(32 * var(--w));
  gap: calc(24 * var(--w));
  margin-bottom: calc(16 * var(--w));
}
.avatar {
  width: calc(100 * var(--w));
  height: calc(100 * var(--w));
  border-radius: 50%;
  background: #f2f2f2;
  overflow: hidden;
  flex-shrink: 0;
}
.avatar-icon {
  width: 100%;
  height: 100%;
}
.user-name {
  font-size: calc(36 * var(--w));
  font-weight: bold;
  color: #323233;
  margin-bottom: calc(8 * var(--w));
}
.user-id {
  font-size: calc(28 * var(--w));
  color: #646566;
}
.form-body {
  background: #fff;
}
.form-item {
  display: flex;
  align-items: center;
  min-height: calc(110 * var(--w));
  padding: 0 calc(32 * var(--w));
  border-bottom: 1px solid #f0f0f0;
  gap: calc(24 * var(--w));
}
.form-item:last-child {
  border-bottom: none;
}
.form-label {
  font-size: calc(30 * var(--w));
  color: #323233;
  white-space: nowrap;
  width: calc(220 * var(--w));
  flex-shrink: 0;
}
.form-label.required::before {
  content: '*';
  color: #f00;
  margin-right: calc(4 * var(--w));
}
.form-input {
  flex: 1;
  height: calc(110 * var(--w));
  border: none;
  outline: none;
  font-size: calc(30 * var(--w));
  color: #323233;
  background: transparent;
}
.form-input::placeholder {
  color: #969799;
}
.input-wrap {
  flex: 1;
  display: flex;
  align-items: center;
  position: relative;
}
.clear-btn {
  width: calc(32 * var(--w));
  height: calc(32 * var(--w));
  flex-shrink: 0;
  margin-left: calc(12 * var(--w));
  cursor: pointer;
}
.picker {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: space-between;
  cursor: pointer;
}
.picker-value {
  font-size: calc(30 * var(--w));
  color: #323233;
}
.picker-value.placeholder {
  color: #969799;
}
.picker-arrow {
  width: calc(28 * var(--w));
  height: calc(28 * var(--w));
  flex-shrink: 0;
}
.footer-btn {
  padding: calc(40 * var(--w)) calc(32 * var(--w));
}
.submit-btn {
  width: 100%;
  height: calc(88 * var(--w));
  background: #2E8CF6;
  color: #fff;
  font-size: calc(36 * var(--w));
  border: none;
  border-radius: calc(8 * var(--w));
  cursor: pointer;
}
.modal-mask {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 100;
}
.modal {
  width: calc(600 * var(--w));
  background: #fff;
  border-radius: calc(16 * var(--w));
  overflow: hidden;
}
.modal-title {
  font-size: calc(36 * var(--w));
  font-weight: bold;
  color: #323233;
  text-align: center;
  padding: calc(40 * var(--w)) calc(32 * var(--w)) calc(16 * var(--w));
}
.modal-body {
  font-size: calc(30 * var(--w));
  color: #646566;
  text-align: center;
  padding: calc(16 * var(--w)) calc(32 * var(--w)) calc(40 * var(--w));
}
.modal-btn {
  border-top: 1px solid #f0f0f0;
  text-align: center;
  font-size: calc(34 * var(--w));
  color: #2E8CF6;
  padding: calc(28 * var(--w)) 0;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/pages/HardshipCertify.vue